import type { Template } from "@/types";

export const PO_07_H0_V7: Template[] = [
{
    id: "po-07-h0v7-01",
    name: "PO 01 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 0, y: 288, width: 156, height: 279, rotation: 0, imageRotation: 0 },
            { id: "2", x: 164, y: 288, width: 156, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 328, y: 288, width: 156, height: 279, rotation: 0, imageRotation: 0 },
            { id: "4", x: 492, y: 288, width: 155, height: 279, rotation: 0, imageRotation: 0 },
            { id: "5", x: 655, y: 288, width: 155, height: 279, rotation: 0, imageRotation: 0 },
            { id: "6", x: 818, y: 288, width: 155, height: 279, rotation: 0, imageRotation: 0 },
            { id: "7", x: 981, y: 288, width: 155, height: 279, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h0v7-02",
    name: "PO 02 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_02.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 54, y: 172, width: 148, height: 251, rotation: 0, imageRotation: 0 },
        { id: "2", x: 54, y: 431, width: 148, height: 251, rotation: 0, imageRotation: 0 },
        { id: "3", x: 210, y: 172, width: 148, height: 251, rotation: 0, imageRotation: 0 },
        { id: "4", x: 210, y: 431, width: 148, height: 251, rotation: 0, imageRotation: 0 },
        { id: "5", x: 366, y: 172, width: 148, height: 251, rotation: 0, imageRotation: 0 },
        { id: "6", x: 366, y: 431, width: 148, height: 251, rotation: 0, imageRotation: 0 },
        { id: "7", x: 699, y: 172, width: 305, height: 510, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-03",
    name: "PO 03 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_03.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 135, y: 87, width: 145, height: 222, rotation: 0, imageRotation: 0 },
        { id: "2", x: 288, y: 87, width: 145, height: 222, rotation: 0, imageRotation: 0 },
        { id: "3", x: 135, y: 317, width: 145, height: 221, rotation: 0, imageRotation: 0 },
        { id: "4", x: 288, y: 317, width: 145, height: 221, rotation: 0, imageRotation: 0 },
        { id: "5", x: 135, y: 546, width: 145, height: 221, rotation: 0, imageRotation: 0 },
        { id: "6", x: 288, y: 546, width: 145, height: 221, rotation: 0, imageRotation: 0 },
        { id: "7", x: 656, y: 87, width: 393, height: 680, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-04",
    name: "PO 04 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 29, y: 0, width: 510, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 604, y: 144, width: 160, height: 280, rotation: 0, imageRotation: 0 },
        { id: "3", x: 772, y: 144, width: 160, height: 280, rotation: 0, imageRotation: 0 },
        { id: "4", x: 940, y: 144, width: 160, height: 280, rotation: 0, imageRotation: 0 },
        { id: "5", x: 604, y: 432, width: 160, height: 279, rotation: 0, imageRotation: 0 },
        { id: "6", x: 772, y: 432, width: 160, height: 279, rotation: 0, imageRotation: 0 },
        { id: "7", x: 940, y: 432, width: 160, height: 279, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-05",
    name: "PO 05 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 45, y: 227, width: 235, height: 402, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 288, y: 227, width: 114, height: 197, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 432, width: 114, height: 197, rotation: 0, imageRotation: 0 },
        { id: "4", x: 410, y: 227, width: 113, height: 197, rotation: 0, imageRotation: 0 },
        { id: "5", x: 410, y: 432, width: 113, height: 197, rotation: 0, imageRotation: 0 },
        { id: "6", x: 613, y: 227, width: 236, height: 402, rotation: 0, imageRotation: 0 },
        { id: "7", x: 857, y: 227, width: 235, height: 402, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-06",
    name: "PO 06 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 54, y: 162, width: 363, height: 530, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 425, y: 162, width: 103, height: 172, rotation: 0, imageRotation: 0 },
        { id: "3", x: 425, y: 342, width: 103, height: 171, rotation: 0, imageRotation: 0 },
        { id: "4", x: 425, y: 521, width: 103, height: 171, rotation: 0, imageRotation: 0 },
        { id: "5", x: 611, y: 162, width: 312, height: 530, rotation: 0, imageRotation: 0 },
        { id: "6", x: 931, y: 162, width: 154, height: 261, rotation: 0, imageRotation: 0 },
        { id: "7", x: 931, y: 431, width: 154, height: 261, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-07",
    name: "PO 07 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_07.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 56, y: 83, width: 199, height: 341, rotation: 0, imageRotation: 0 },
        { id: "2", x: 56, y: 432, width: 199, height: 340, rotation: 0, imageRotation: 0 },
        { id: "3", x: 263, y: 83, width: 198, height: 341, rotation: 0, imageRotation: 0 },
        { id: "4", x: 263, y: 432, width: 198, height: 340, rotation: 0, imageRotation: 0 },
        { id: "5", x: 469, y: 83, width: 404, height: 689, rotation: 0, imageRotation: 0 },
        { id: "6", x: 881, y: 83, width: 199, height: 341, rotation: 0, imageRotation: 0 },
        { id: "7", x: 881, y: 432, width: 199, height: 340, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-08",
    name: "PO 08 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_08.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 56, y: 83, width: 199, height: 341, rotation: 0, imageRotation: 0 },
        { id: "2", x: 263, y: 83, width: 198, height: 341, rotation: 0, imageRotation: 0 },
        { id: "3", x: 469, y: 83, width: 198, height: 341, rotation: 0, imageRotation: 0 },
        { id: "4", x: 56, y: 432, width: 199, height: 340, rotation: 0, imageRotation: 0 },
        { id: "5", x: 263, y: 432, width: 198, height: 340, rotation: 0, imageRotation: 0 },
        { id: "6", x: 469, y: 432, width: 198, height: 340, rotation: 0, imageRotation: 0 },
        { id: "7", x: 675, y: 83, width: 405, height: 689, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-09",
    name: "PO 09 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 56, y: 83, width: 199, height: 341, rotation: 0, imageRotation: 0 },
        { id: "2", x: 56, y: 432, width: 199, height: 340, rotation: 0, imageRotation: 0 },
        { id: "3", x: 263, y: 83, width: 404, height: 689, rotation: 0, imageRotation: 0 },
        { id: "4", x: 675, y: 83, width: 198, height: 341, rotation: 0, imageRotation: 0 },
        { id: "5", x: 675, y: 432, width: 198, height: 340, rotation: 0, imageRotation: 0 },
        { id: "6", x: 881, y: 83, width: 199, height: 341, rotation: 0, imageRotation: 0 },
        { id: "7", x: 881, y: 432, width: 199, height: 340, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h0v7-10",
    name: "PO 10 - H0V7",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h0_v7_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 202, width: 127, height: 221, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 431, width: 127, height: 220, rotation: 0, imageRotation: 0 },
        { id: "3", x: 135, y: 202, width: 127, height: 221, rotation: 0, imageRotation: 0 },
        { id: "4", x: 135, y: 431, width: 127, height: 220, rotation: 0, imageRotation: 0 },
        { id: "5", x: 270, y: 202, width: 284, height: 448, rotation: 0, imageRotation: 0 },
        { id: "6", x: 562, y: 202, width: 284, height: 448, rotation: 0, imageRotation: 0 },
        { id: "7", x: 854, y: 202, width: 283, height: 448, rotation: 0, imageRotation: 0 }
    ],
}
];